if (!customElements.get('ndx-free-shipping')) {
  customElements.define(
    'ndx-free-shipping',
    class NdxFreeShipping extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('.ndx-free-shipping__message');
        this.track = this.querySelector('.ndx-free-shipping__track');
        this.fill = this.querySelector('.ndx-free-shipping__fill');
        this.render(Number(this.dataset.subtotalCents));

        if (this.closest('#main-cart-items')) {
          this.onCountryChange = (event) => {
            if (event.target.matches('#mc-country-select')) this.render(Number(this.dataset.subtotalCents));
          };
          document.addEventListener('change', this.onCountryChange);
          const cartFooter = document.querySelector('#main-cart-footer');
          if (cartFooter) {
            this.countryObserver = new MutationObserver(() => this.render(Number(this.dataset.subtotalCents)));
            this.countryObserver.observe(cartFooter, { childList: true, subtree: true });
          }
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
            if (Number.isFinite(Number(cartData?.total_price))) {
              this.render(Number(cartData.total_price));
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.onCountryChange) document.removeEventListener('change', this.onCountryChange);
        if (this.countryObserver) this.countryObserver.disconnect();
      }

      currentCountry() {
        const marketCountry = this.dataset.country;
        const appCountry = document.querySelector('#mc-country-select')?.value;
        if (this.closest('#main-cart-items') && appCountry) {
          try {
            sessionStorage.setItem('ndx_shipping_country', JSON.stringify({ market: marketCountry, shipping: appCountry }));
          } catch (error) {}
          return appCountry;
        }

        try {
          const saved = JSON.parse(sessionStorage.getItem('ndx_shipping_country') || 'null');
          if (saved?.market === marketCountry && saved?.shipping) return saved.shipping;
          if (saved) sessionStorage.removeItem('ndx_shipping_country');
        } catch (error) {}
        return marketCountry;
      }

      render(subtotalCents) {
        const thresholdEurCents = this.currentCountry() === 'EE' ? 9999 : 14999;
        const currency = this.dataset.currency;
        const shopCurrency = this.dataset.shopCurrency;
        const rate = currency === shopCurrency ? 1 : Number(window.Shopify?.currency?.rate);

        if (!Number.isFinite(subtotalCents) || !Number.isFinite(thresholdEurCents) || !Number.isFinite(rate) || rate <= 0) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const thresholdCents = Math.round(thresholdEurCents * rate);
        const remainingCents = Math.max(0, thresholdCents - subtotalCents);
        const percent = Math.min(100, Math.max(0, (subtotalCents / thresholdCents) * 100));
        const locale = document.documentElement.lang || window.Shopify?.locale || 'en';
        const formattedRemaining = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(remainingCents / 100);

        this.message.textContent = remainingCents === 0
          ? this.dataset.unlockedTemplate
          : this.dataset.remainingTemplate.replace('NDX_AMOUNT', formattedRemaining);
        this.track.setAttribute('aria-label', this.message.textContent);
        this.fill.style.width = `${percent}%`;
        this.track.setAttribute('aria-valuenow', String(Math.round(percent)));
        this.dataset.subtotalCents = String(subtotalCents);
      }
    }
  );
}
